// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Date__pc_only___3TNhM","sp_only":"Date__sp_only___zGVBv","date":"Date__date___Fh7cg"};